export default {
	'add-new-slider': '',
	slider: '',
	'the-slider': ''
}